import { IApplicationState } from '../../types/redux';
import { ISuburbanMortgageData } from '../../types/suburban/data';

const defaultValue: IApplicationState['suburban'] = {
  mortgageData: {} as ISuburbanMortgageData,
  goshelpMortgage: {} as ISuburbanMortgageData,
};

export function suburbanReducer(state: IApplicationState['suburban'] = defaultValue): IApplicationState['suburban'] {
  return state;
}
